import { useMemo } from 'react'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import { DashboardWidget } from 'features/widget/types'
import { WidgetId } from 'features/types'

import { getIndexValue } from './utils'

const getDemographicData = (widgetData: DashboardWidget<InsightCount | AnnotatedMetricResult>) => {
  const resultData = widgetData.data![0]!.results![0]!.data as InsightCount
  const totalCountFromMetricSearch =
    widgetData.data.length > 1 &&
    (widgetData.data![1]!.results![0]!.data as AnnotatedMetricResult)!.metrics![0]!.dataset![0]
      .set![0] // * special handle for INTEREST and PROFESSIONS

  const insightSet = resultData!.insights![0]!.dataset![0].set ?? []
  const insightStatus = resultData!.insights![0]!.dataset![0].status

  const { totalCount, maxIndex } = insightSet.reduce(
    (acc, insight) => ({
      ...acc,
      totalCount: totalCountFromMetricSearch || acc.totalCount + insight.value!,
      maxIndex: Math.max(getIndexValue(insight.index!), acc.maxIndex)
    }),
    {
      totalCount: 0,
      maxIndex: 0
    }
  )

  return {
    status: insightStatus,
    insights: insightSet,
    totalCount,
    isEmpty: !insightSet.length || totalCount === 0,
    maxIndex
  }
}

const useDemographicData = (widgetId: WidgetId) => {
  const widgetData = useDashboardWidgetData<InsightCount | AnnotatedMetricResult>(widgetId)
  const demographicData = useMemo(() => getDemographicData(widgetData), [widgetData])

  return demographicData
}

export default useDemographicData
